import { FC } from 'react';
import Typography from '@components/common/typography';
import styles from './styles.module.scss';
import Button from '@components/common/button';
import { useLocales } from '@hooks/helpers/useLocales';
import illustration from '@svg/illustrations/success_kyc.svg';

interface IProps {
    onClose: () => void;
}

const KycSuccess: FC<IProps> = ({ onClose }) => {
    // const { t } = useTranslation('shufti_pro');
    const { submitLocale } = useLocales();

    return (
        <div className={styles.success_wrapper}>
            <img src={illustration} alt="illustration" />
            <Typography className={styles.title} alignment="center" variant="h4">
                Identity verified
            </Typography>
            <Typography alignment="center">
                Congratulations! Your identity has been successfully verified. You now have full
                access to all XEPPT products and services
            </Typography>
            <div className={styles.actions}>
                <Button size="medium" variant="primary" onClick={onClose}>
                    {submitLocale('close')}
                </Button>
            </div>
        </div>
    );
};

export default KycSuccess;
